<template>
  <div class="page-taglist">
    <p class="tag-name">
      标签名称：
      <b>{{tagName}}</b>
    </p>

    <div class="tag-bar">
      <el-popover
        placement="bottom"
        width="230"
        trigger="click"
        v-model="showP"
        :disabled="multipleSelection.length == 0"
      >
        <TagListMove :id="id" :tagname="tagName" @close="showP = false" @select="handlerSelect" />
        <button
          slot="reference"
          :class="['tag-movebtn', {
            'active': multipleSelection.length > 0
          }]"
        >
          <i class="iconfont iconmove"></i>
          <span>移动标签</span>
        </button>
      </el-popover>

      <el-input class="tag-search" placeholder="用户昵称" v-model="searchword">
        <template slot="append">
          <i @click="handlerSearch" class="el-icon-search searchbtn"></i>
        </template>
      </el-input>
    </div>
    <div class="datatable">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        v-loading="loading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="头像" width="120">
          <template slot-scope="scope">
            <el-image class="headerimg" :src="scope.row.headImg" lazy></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="昵称"></el-table-column>
        <el-table-column prop="location" label="国家/省份/城市"></el-table-column>
        <el-table-column prop="openId" label="openid"></el-table-column>
        <el-table-column prop="address" label="标签">
          <template slot-scope="scope">
            <el-tag
              type="info"
              class="tags-tag"
              v-for="tag in scope.row.customTags"
              :key="tag.customTagId"
              size="mini"
              effect="plain"
              color="#fff"
            >{{tag.name}}</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagina">
      <el-pagination
        layout="prev, pager, next"
        :total="itotal"
        :page-size="isize"
        @current-change="v => ipage = v"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import TagListMove from '@/components/tagListMove';

export default {
  name: 'TagsList',

  props: ['id'],

  components: {
    TagListMove,
  },

  data() {
    return {
      loading: true,
      tagName: '',
      tagId: 0,
      searchword: '',
      ipage: 1,
      isize: 10,
      itotal: 0,
      tableData: [],
      multipleSelection: [],
      searched: false,
      showP: false,
    };
  },

  watch: {
    searchword(val, oldval) {
      if (!val && oldval && this.searched) {
        this.searched = false;
        this.ipage = 1;
        this.getData();
      }
    },
    ipage() {
      this.getData();
    },
  },

  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    handlerSelect(item) {
      console.log(item);
      this.showP = false;
      let followers = [];
      this.multipleSelection.forEach(item => {
        followers.push(String(item.openId));
      });
      this.onMoveTags({
        followers,
        customTagId: item.customTagId,
      });
    },

    async onMoveTags(data) {
      let res = await this.$http.post(
        `/api/${this.id}/custom-tag/${this.tagId}/move/followers`,
        data,
      );
      if (res) {
        this.$message({
          message: '标签移动成功',
          type: 'success',
        });
        this.ipage = 1;
        this.getData();
      }
    },

    async handlerSearch() {
      if (!this.searchword) {
        this.$message.error('用户昵称未填写');
        return false;
      }

      this.ipage = 1;
      this.searched = true;
      this.getData();
    },

    requestAPI(data = {}) {
      let url = `/api/${this.id}/custom-tag/${this.tagId}/followers`;
      let res = this.$http.get(url, {
        params: Object.assign(
          {
            page: this.ipage,
            size: this.isize,
          },
          data,
        ),
      });

      return res;
    },

    async getData() {
      this.loading = true;
      let res = await this.requestAPI({
        key: this.searchword,
      });
      if (res) {
        this.tagName = res.name;
        this.itotal = res.followers.totalSize;
        this.tableData = res.followers.list;
      }
      setTimeout(() => {
        this.loading = false;
      }, 300);
    },
  },
  created() {
    const { tagid } = this.$route.query;
    this.tagId = tagid;
  },

  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.page-taglist {
  .datatable {
    margin-top: 15px;
    min-height: 560px;
    background: #fff;
    border: 1px solid rgba(220, 223, 230, 0.5);

    /deep/ .el-table th {
      background: #fff;
    }

    /deep/ .el-tag {
      padding: 0 10px;
      margin-right: 12px;
      margin-bottom: 10px;
      height: 24px;
      line-height: 23px;
    }

    .headerimg {
      width: 46px;
      height: 46px;
    }
  }
  .pagina {
    margin: 20px 0;
    text-align: center;
  }
}

.tag {
  &-name {
    padding-left: 26px;
    height: 45px;
    line-height: 45px;
    background: #606266;
    color: #fff;
    font-size: 14px;
  }

  &-bar {
    margin-top: 20px;
    height: 40px;
    /deep/ .el-input-group__append {
      cursor: pointer;
    }
  }
  &-movebtn {
    box-sizing: border-box;
    margin-top: 2px;
    width: 100px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    background: #e5e5e5;
    color: #606266;
    font-size: 12px;
    border: none;
    outline: none;
    cursor: pointer;

    &.active {
      background: #17cfbb;
      color: #fff;

      i {
        color: #fff;
      }
    }

    i {
      margin-right: 8px;
      font-size: 16px;
      color: #333;
    }
  }
  &-search {
    float: right;
    width: 240px;

    .searchbtn {
      cursor: pointer;
      font-size: 18px;
    }
  }
}
.tags-tag {
  margin-right: 8px !important;
  margin-bottom: 5px !important;
}
</style>
